import { createEvent, createStore, sample } from 'effector';

export const setPostCardImage = createEvent<string>();
export const $postCardImage = createStore<string>('');

export const setProcessedPostCardImage = createEvent<string>();
export const $processedPostCardImage = createStore<string>('');

export const setIsPostCardPreparing = createEvent<boolean>();
export const $isPostCardPreparing = createStore<boolean>(false);

export const setPostCardCanvas = createEvent<HTMLCanvasElement>();
export const $postCardCanvas = createStore<HTMLCanvasElement | null>(null);

sample({
  clock: setIsPostCardPreparing,
  target: $isPostCardPreparing
});

sample({
  clock: setPostCardImage,
  target: $postCardImage
});

sample({
  clock: setProcessedPostCardImage,
  target: $processedPostCardImage
});

sample({
  clock: setPostCardCanvas,
  target: $postCardCanvas
});
